export const FolderIllustration = ({ className, style }: ComponentStyling) => (
  <svg
    className={className}
    fill="none"
    style={style}
    viewBox="0 0 42 42"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1033_466)">
      <path
        d="M33.4418 3.12061H14.1744V11.1106H37.5569V7.23402C37.5569 4.96567 35.7108 3.12061 33.4418 3.12061Z"
        fill="#D9E6FF"
      />
      <path
        d="M22.5352 12.3403H0V4.92636C0 2.20972 2.21068 0 4.92828 0H12.1336C12.8497 0 13.5396 0.150925 14.1664 0.434509C15.0418 0.828964 15.7939 1.47913 16.3213 2.3286L22.5352 12.3403Z"
        fill="#2453B2"
      />
      <path
        d="M42 13.9999V37.8812C42 40.1525 40.1511 41.9998 37.8789 41.9998H4.12111C1.84891 41.9998 0 40.1525 0 37.8812V9.88037H37.8789C40.1511 9.88037 42 11.7283 42 13.9999Z"
        fill="#2453B2"
      />
      <path
        d="M42 13.9999V37.8812C42 40.1525 40.1511 41.9998 37.8789 41.9998H21V9.88037H37.8789C40.1511 9.88037 42 11.7283 42 13.9999Z"
        fill="#2453B2"
      />
      <path
        d="M32.0479 25.94C32.0479 32.0325 27.0918 36.9889 21 36.9889C14.9082 36.9889 9.95203 32.0325 9.95203 25.94C9.95203 19.8486 14.9082 14.8921 21 14.8921C27.0918 14.8921 32.0479 19.8486 32.0479 25.94Z"
        fill="#EFEFFF"
      />
      <path
        d="M32.0479 25.94C32.0479 32.0325 27.0918 36.9889 21 36.9889V14.8921C27.0918 14.8921 32.0479 19.8486 32.0479 25.94Z"
        fill="#D9E6FF"
      />
      <path
        d="M24.561 26.0753C24.3306 26.2704 24.0483 26.3656 23.7685 26.3656C23.4183 26.3656 23.0703 26.2173 22.8268 25.9282L22.2304 25.2213V29.8494C22.2304 30.5287 21.6793 31.0799 21 31.0799C20.3207 31.0799 19.7695 30.5287 19.7695 29.8494V25.2213L19.1732 25.9282C18.7342 26.4476 17.9584 26.514 17.439 26.0753C16.9199 25.6373 16.8532 24.8612 17.2913 24.3418L19.7269 21.4543C20.0444 21.0788 20.5078 20.8628 21 20.8628C21.4922 20.8628 21.9555 21.0788 22.2731 21.4543L24.7087 24.3418C25.1467 24.8612 25.0801 25.6373 24.561 26.0753Z"
        fill="#A6C3FF"
      />
      <path
        d="M24.561 26.0753C24.3306 26.2704 24.0483 26.3656 23.7686 26.3656C23.4183 26.3656 23.0703 26.2173 22.8268 25.9282L22.2305 25.2213V29.8494C22.2305 30.5287 21.6793 31.0799 21 31.0799V20.8628C21.4922 20.8628 21.9555 21.0788 22.2731 21.4543L24.7087 24.3418C25.1467 24.8612 25.0801 25.6373 24.561 26.0753Z"
        fill="#2453B2"
      />
    </g>
    <defs>
      <clipPath id="clip0_1033_466">
        <rect width="42" height="42" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
